import { useForm } from "react-hook-form";
import { postUploadContactFileRoute } from "@api-routes";
import { useFetch } from "@common/hook/useFetch";
import { getLanguage } from "@utils/changeLanguage";

export const useUploadContactFile = (callback: () => void) => {
    const [uploadContactDocumentState, { post }] = useFetch();
    const formMethods = useForm<{ base64File: string; docType: string }>({
        defaultValues: { base64File: "", docType: "" },
    });

    const { handleSubmit, setValue } = formMethods;

    const handleOnSubmit = handleSubmit((formData) => {
        const lang = getLanguage();
        post<boolean>(postUploadContactFileRoute(formData.docType, lang), {
            body: { base64File: formData.base64File },
        }).then((uploadIdentityDocumentResponse) => {
            if (uploadIdentityDocumentResponse) {
                setValue("base64File", undefined);
                callback();
            }
        });
    });

    return { formMethods, handleOnSubmit, uploadContactDocumentState };
};
